import React, { useCallback, useEffect, useMemo } from 'react';

import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import {
    AccordionPanel,
    CheckboxGroup,
} from 'reaxl';
import {
    FilterCheckboxLabel,
} from 'reaxl-filters';

import getFilterTitle from '@/utilities/getFilterTitle';

import srpFiltersDuck from '@/ducks/srp/srpFiltersDuck.js';

import FilterPlaceholder from './FilterPlaceholder';

function SeatsFilter({
    onOptionChange = () => { },
    handleShowExpansion = () => { },
}) {
    const seatsValues = useSelector(srpFiltersDuck.selectors.getSeatsValues);
    const seatsOptions = useSelector(srpFiltersDuck.selectors.getSeatsOptions);

    const filterName = 'maximumSeating';
    const isExpanded = useSelector(useCallback((state) => srpFiltersDuck.selectors.isExpansionActive(state, filterName), [filterName]));
    const showFilter = useMemo(() => isExpanded && Object.keys(seatsOptions).length !== 0, [isExpanded, seatsOptions]);
    const title = useMemo(() => getFilterTitle('Number of Seats', seatsValues), [seatsValues]);

    // expand the panel if active options inside of it
    const shouldExpand = useMemo(() => seatsValues.length > 0, [seatsValues.length]);
    useEffect(() => {
        if (shouldExpand) {
            handleShowExpansion(filterName);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldExpand, filterName]);

    const labeledOptions = seatsOptions?.options?.map((option) => {
        const optionCopy = { ...option };

        return {
            ...optionCopy,
            label: <FilterCheckboxLabel {...optionCopy} />,
            value: optionCopy.value,
        };
    });

    return (
        <AccordionPanel
            eventKey={filterName}
            data-cmp="SeatsFilter"
            title={title}
            contentPadding={5}
        >
            {!showFilter && <FilterPlaceholder uniqueKey={filterName} />}
            {showFilter && (
                <CheckboxGroup
                    name="maximumSeating"
                    value={seatsValues}
                    columnClasses="col-xs-4 col-lg-2"
                    options={labeledOptions}
                    onChange={(event) => onOptionChange(event, seatsOptions)}
                />
            )}
        </AccordionPanel>
    );

}

SeatsFilter.displayName = 'SeatsFilter';
SeatsFilter.propTypes = {
    onOptionChange: PropTypes.func,
    handleShowExpansion: PropTypes.func,
};

export default React.memo(SeatsFilter);
